import reserved_flag from "../../../Assets/Flags/reserved_flag.svg";
import { ICardHUProps } from "../../../Interfaces";
import { formatter } from "../../../Utils";
import { TotalCost } from "../OccupiedInfo/style";
import { Container, Flag, State, StateContainer } from "./style";

interface IReservedInfos {
  state: "available" | "occupied" | "maintenance" | "reserved";
}

const ReservedInfos = ({
  data,
  state,
}: ICardHUProps & IReservedInfos) => {
  return (
    <div>
      <Container>
        <StateContainer>
          <Flag src={reserved_flag} state={state} />
          <State state={state}>reservado</State>
          {state === "reserved" && (
            <TotalCost>{formatter.format(data.price)}</TotalCost>
          )}
        </StateContainer>
      </Container>
    </div>
  );
};
export default ReservedInfos;
